module.exports = __webpack_public_path__ + "img/Wallet_BG.ab6914ef.svg";